import React from 'react';

const HeroImage = ({ imageUrl, title }) => {
  return (
    <div
      style={{
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '400px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        textShadow: '0 2px 4px rgba(0,0,0,0.7)',
        position: 'relative',
      }}
    >
      {/* Optional title overlay */}
      {title && (
        <h1 style={{ fontSize: '3rem', fontWeight: 'bold' }}>
          {title}
        </h1>
      )}

      {/* Overlay effect to darken the background */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.4)', // Dark overlay
        }}
      ></div>
    </div>
  );
};

export default HeroImage;
